import { Button } from '@/components/ui/Button'
import { StepRail } from '@/components/ui/StepRail'
import { confPct } from '@/lib/format'
import type { Workflow } from '@/types/dashboard'

interface Props {
  workflow: Workflow
  proposing: boolean
  onPropose: (id: string) => void
  onCopy: (id: string) => void
}

export function WorkflowRow({ workflow: w, proposing, onPropose, onCopy }: Props) {
  const pct = confPct(w.confidence)
  return (
    <article className="row">
      <div className="row-top">
        <div>
          <div className="row-title">{w.name}</div>
          <div className="row-meta">
            {w.domain} · {w.frequency} · {w.occurrence_count}×
          </div>
        </div>
        <div className="conf" title="Confidence">
          <b>
            <i style={{ width: `${pct}%` }} />
          </b>{' '}
          {pct}%
        </div>
      </div>
      <StepRail steps={w.steps || []} />
      <div className="row-actions">
        <Button variant="primary" size="sm" disabled={proposing} onClick={() => onPropose(w.id)}>
          {proposing ? 'Orchestrating…' : 'Propose'}
        </Button>
        <Button size="sm" onClick={() => onCopy(w.id)}>
          Copy id
        </Button>
      </div>
    </article>
  )
}
